import { render, staticRenderFns } from "./RegisterSongStep2EnterLyrics.vue?vue&type=template&id=220f114d&scoped=true"
import script from "./RegisterSongStep2EnterLyrics.vue?vue&type=script&lang=ts"
export * from "./RegisterSongStep2EnterLyrics.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongStep2EnterLyrics.vue?vue&type=style&index=0&id=220f114d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f114d",
  null
  
)

export default component.exports